// extracted by mini-css-extract-plugin
export default {"container":"Hero_container__3YUmt","container-lg":"Hero_container-lg__5cDwk","wrapper":"Hero_wrapper__o-bJR","title":"Hero_title__mcR28"};